import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, ScrollView } from "native-base";
import { isWeb } from "@madmedical/utils";
import { useTranslation } from "@madmedical/i18n";
import { useRouteNavigate } from "../../providers/routing";
import Alert from "../../molecules/Alert";
import PreOpAlert from "./PreOpAlert";
import Evaluations from "./Evaluations";
import Charts from "./Charts";
import Devices from "./Devices";
const Health = ({ charts, insulinList, pregnancyDashboard }) => {
    const navigate = useRouteNavigate();
    const { t } = useTranslation();
    return (_jsxs(ScrollView, { children: [_jsxs(Box, Object.assign({ width: "100%", bgColor: "gray.50", px: {
                    base: 4,
                    md: 0,
                }, pb: {
                    base: 90,
                    md: 0,
                } }, { children: [_jsx(PreOpAlert, {}), pregnancyDashboard, _jsx(Charts, { charts: charts }), _jsx(Alert, { title: t("dashboard:baseInfo"), showCloseButton: false, description: t("dashboard:baseDescription"), links: [
                            {
                                text: t("continue"),
                                onPress: () => {
                                    navigate("onboarding", {});
                                },
                            },
                        ] }), _jsx(Evaluations, {}), insulinList, isWeb && _jsx(Devices, {})] })), _jsx(Box, { h: 10, w: 1 })] }));
};
export default Health;
